import { render, staticRenderFns } from "./remittancepayable.vue?vue&type=template&id=5d5aed9e&scoped=true&"
import script from "./remittancepayable.vue?vue&type=script&lang=js&"
export * from "./remittancepayable.vue?vue&type=script&lang=js&"
import style0 from "./remittancepayable.vue?vue&type=style&index=0&id=5d5aed9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5aed9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VIcon})
